import {AbstractPart} from "./AbstractPart";
import {nsForm} from "../../nsForm";
import {IFormPartParameters} from "./index";
import {_} from 'lodash';
import str2Bool = nsForm.str2Bool;
import listboxHtml from './listbox.html?raw';

export let template = listboxHtml;

export class viewModel extends AbstractPart<string | string[]> {
    private readonly isRequired: boolean;
    private readonly isMultiple: boolean;

    constructor(params: IFormPartParameters) {
        super(params);
        this.isRequired = str2Bool(this.parameters[4] ?? '');
        this.isMultiple = str2Bool(this.parameters[5] ?? '');
        this.attr = {
            multiple: this.isMultiple,
            required: this.isRequired,
        };
        this.value(this.options().filter(o => o.selected).map(o => o.value));
    }

    private options(): any[] {
        const options = (this.parameters[2] ?? '').split('|');
        const selected = (this.parameters[3] ?? '').split('|');
        return this.getOptions(options, selected);
    }

    protected override getOptions(options: any[], selectedValue: any): any[] {
        const ret = super.getOptions(options, selectedValue);
        return _.sortBy(ret, (o: { text?: string }) => o.text?.toLowerCase())
    }

    override isValid(): boolean {
        const a = this.isRequired ? !!this.value() : true;
        this.et.update(!a, this.value, 'Mangler verdi');
        return a;
    }

    override getSubmitData(): string {
        const val = this.value();
        if (Array.isArray(val)) {
            return val.join('|');
        }
        return val ?? '';
    }
}
